module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921034151_T.9528dbd9.jpg";